import { AppStore as AppStoreType } from '@/generated/contentfulTypes';
import { Languages } from '@/common/utils/constants';
import dayjs from '@/common/lib/dayjs';

export interface Schedule {
  id: string;
  start_datetime: string;
  class?: {
    name: string;
    duration?: string;
    imgUrl?: string;
    description?: string;
    address?: {
      address_line1: string;
      address_line2: string;
    };
  };
}

export interface ClassfinderProps {
  studioId: string | null;
  lang: Languages;
  findAClassTranslations: Record<string, string>;
  filterTranslations: Record<string, string>;
  appStore?: AppStoreType;
}

export interface DaySchedule {
  schedules: Schedule[];
  date: dayjs.Dayjs;
}

export interface ScheduleData {
  [key: string]: DaySchedule;
}

export interface Instructor {
  firstName: string;
  lastName: string;
  id: number;
  publicName: string | null;
}

export interface Location {
  id: number;
  name: string;
  description: string;
}

export interface Slot {
  id: number;
  startDateTime: string;
  endDateTime: string;
  maxParticipants: number;
  maxWaitingListParticipants: number;
  bookedParticipants: number;
  waitingListParticipants: number;
  additionalParticipants: number;
  earliestBookingDateTime: string;
  latestBookingDateTime: string | null;
  instructors: Instructor[];
  location: Location;
}

export interface ClassSchedule {
  class: {
    id: number;
    title: string;
    description: string;
    duration: number;
    type: string;
    category: string;
    bookable: boolean;
    imgUrl: string;
  };
  slots: Slot[];
}

export interface ServiceSchedule {
  service: {
    id: number;
    title: string;
    description: string;
    duration: number;
    type: string;
    category: string;
    bookable: boolean;
    imgUrl: string;
  };
  slots: Slot[];
}

export interface OrganisedSchedules {
  grouped: ScheduleData;
  filtered: ScheduleData;
}

export const CLASSFINDER_ENTITY_TYPES = {
  SERVICES: "services",
  CLASSES: "classes",
} as const;

export type ClassfinderEntityType =
  (typeof CLASSFINDER_ENTITY_TYPES)[keyof typeof CLASSFINDER_ENTITY_TYPES];

export interface ScheduleDateRange {
  start: string;
  end: string;
  max_days: number;
}

export interface ClassScheduleResponse {
  class_schedules: ClassSchedule[];
  date_range: ScheduleDateRange;
}

export interface ServiceScheduleResponse {
  service_schedules: ServiceSchedule[];
  date_range: ScheduleDateRange;
}

export type SchedulesResponse = ClassScheduleResponse | ServiceScheduleResponse | null;

export enum FilterVariant {
  Clubs = 'clubs',
  Classes = 'classes'
}
